import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CentrexServiceModel } from '../models/centrex-service.model';
import { ApiService } from './api.service';
import { ServiceBase } from './service-base';

@Injectable({
  providedIn: 'root',
})
export class CentrexServicesService extends ServiceBase {
  constructor(private http: HttpClient, private apiService: ApiService) {
    super();
  }

  private createHeaders(additionalHeaders?: {
    [key: string]: string;
  }): HttpHeaders {
    const token = this.apiService.getAccessToken();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    if (additionalHeaders) {
      Object.keys(additionalHeaders).forEach((key) => {
        headers = headers.set(key, additionalHeaders[key]);
      });
    }

    return headers;
  }

  private handleError(error: any): Observable<never> {
    console.error('Erreur CentrexServicesService', error);
    return throwError(() => error);
  }

  getServices(
    organizationId: string,
    platform: string
  ): Observable<CentrexServiceModel[]> {
    const url = `${this.apiUrl}/api/centrex/services`;
    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
      'X-CentrexPlatform': platform,
    });

    return this.http
      .get<CentrexServiceModel[]>(url, { headers })
      .pipe(catchError(this.handleError));
  }

  getServiceByName(
    organizationId: string,
    platform: string,
    serviceName: string
  ): Observable<CentrexServiceModel> {
    const url = `${this.apiUrl}/api/centrex/services/${serviceName}`;
    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
      'X-CentrexPlatform': platform,
    });

    return this.http
      .get<CentrexServiceModel>(url, { headers })
      .pipe(catchError(this.handleError));
  }

  createService(
    organizationId: string,
    platform: string,
    service: CentrexServiceModel
  ): Observable<boolean> {
    const url = `${this.apiUrl}/api/centrex/services`;
    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
      'X-CentrexPlatform': platform,
    });

    return this.http
      .post<boolean>(url, service, { headers })
      .pipe(catchError(this.handleError));
  }

  updateService(
    organizationId: string,
    platform: string,
    serviceName: string,
    service: CentrexServiceModel
  ): Observable<boolean> {
    const url = `${this.apiUrl}/api/centrex/services/${serviceName}`;
    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
      'X-CentrexPlatform': platform,
    });

    return this.http
      .patch<boolean>(url, service, { headers })
      .pipe(catchError(this.handleError));
  }

  deleteService(
    organizationId: string,
    platform: string,
    serviceName: string
  ): Observable<boolean> {
    const url = `${this.apiUrl}/api/centrex/services/${serviceName}`;
    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
      'X-CentrexPlatform': platform,
    });

    return this.http
      .delete<boolean>(url, { headers })
      .pipe(catchError(this.handleError));
  }
}
